import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import DateEventSelector from './DateEventSelector';
import './styles.css';

function SiteEventSelector() {
    const [selectedSite, setSelectedSite] = useState('');
    const [selectedSiteName, setSelectedSiteName] = useState('');
    const [sites, setSites] = useState([]);
    const [selectedImageUrl, setSelectedImageUrl] = useState('');
    const { stateId, selectedStateName } = useParams();
    
    //const baseUrl = 'http://127.0.0.1:8000'; // use this if developing locally without using docker, ngrok, or prod enviornments
    const baseUrl = process.env.REACT_APP_API_BASE_URL; //this url should be of load balancer in AWS ECS and http://0.0.0.0:8000 for local

    useEffect(() => {
        setSelectedImageUrl('');
        setSelectedSite('');
        setSelectedSiteName('');
        setSites([]);
    }, [stateId]);

    const handleSiteChange = useCallback((event) => {
        const siteId = event.target.value;
        const site = sites.find(site => site.id === Number(siteId));
        const siteName = site ? site.site_name : '';
        setSelectedSite(siteId);
        setSelectedSiteName(siteName);
        
    }, [sites]);

    useEffect(() => {
        if (stateId) {
            fetch(`${baseUrl}/api/states/${stateId}/sites/`)
                .then(response => response.json())
                .then(data => {
                    setSites(data);
                    if (data.length > 0) {
                        setSelectedSite(data[0].id);
                        setSelectedSiteName(data[0].site_name);
                    }
                })
                .catch(error => console.error('Error fetching sites:', error));
        }
    }, [stateId]);

    useEffect(() => {
        if (stateId) {
            fetch(`${baseUrl}/api/states/${stateId}/`)
                .then(response => response.json())
                .then(data => {
                    // setSelectedImageUrl(baseUrl + data.location_map);
                    setSelectedImageUrl(data.location_map);
                })
                .catch(error => console.error('Error fetching location map:', error));
        }
    }, [stateId]);

    return (
        <div className="state-container">
            <h1>Selected State: {selectedStateName}</h1>
            <br />
            <p>
                
                This page displays suspected radio-frequency interference (RFU) in the following manner:
                {/* <br />
                localized disruptions. The contour plot offers a comprehensive view of satellite jamming 
                <br />
                incidents detected across multiple observation sites within the chosen state. Through the  
                <br />
                site-specific plots, you can monitor the jamming events occurring every second of the day, 
                <br />
                providing real-time insights into satellite interference activities. */}
            </p>
            <br />
            <ol>
                <li>
                    State-Wide Animation: An animation displaying the spatial-and-temporal distribution 
                    {/* <br />  */}
                    of the strongest hourly RFIs over the most recent 24-hour period on processed data.
                </li>
                <br /> 
                <li>
                    Monthly DOY-vs-TOD: The day-of-year (DOY) versus time of day (TOD) monthly RFI
                    {/* <br />  */}
                    distribution at an example CORS station.
                </li>
                <br /> 
                <li>
                    Daily Time Series: The most recent 24-hour period of the ratio of detection test statistic
                    {/* <br />  */}
                    over threshold at the same example location.
                </li>
            </ol>
            <br />
            <div className="site-event-dropdown">
                <div className="site-dropdown">
                    <div className="max-image">
                        {selectedImageUrl && <img src={selectedImageUrl} alt="" className="max-width-image" />}
                    </div>
                </div>
                Use drop-down menus to change the date (year, month, and day) of the animation as well as location 
                <br />
                (station identifiers can be found on the state map) of the DOY vs TOD plot and of the time series:
                <div className="site-dropdown-menu">
                    {/* <p> */}
                        {/* <br />
                        <br /> */}
                        {/* Use drop-down menus to change the date (year, month, and day) of the animation as well as location 
                        <br />
                        (station identifiers can be found on the state map) of the DOY vs TOD plot and of the time series  */}
                        {/* <br />
                        <br /> */}
                    {/* </p> */}
                    <br />
                    <br />
                    <select value={selectedSite} onChange={handleSiteChange}>
                        <option value="">Select a site</option>
                        {sites.map(site => (
                            <option key={site.id} value={site.id}>{site.site_name}</option>
                        ))}
                    </select>
                </div>
            </div>
            {stateId && selectedSite && selectedSiteName && <DateEventSelector stateId={stateId} selectedSite={selectedSite} selectedSiteName={selectedSiteName} />}
        </div>
    );
}

export default SiteEventSelector;
